/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'invite-envelope': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _fill="currentColor" fill-rule="nonzero"><path pid="0" d="M21.488 18.848c0 1.875-1.683 2.125-1.98 2.16h-.883c-.277-.035-2.125-.219-2.125-2.547h1.664c0 1.375.777 1.316.895 1.316.128 0 .765-.023.765-.918 0-1.797-3.047-1-3.047-3.687 0-1.844 1.672-2.129 1.97-2.164l.89.023c.281.047 1.863.38 1.863 2.492h-1.664c0-1.105-.516-1.28-.73-1.28-.118 0-.665.03-.665.937 0 1.582 3.047 1.09 3.047 3.668z"/><path pid="1" d="M18.5 12.008h1v2h-1v-2zm0 9h1v1h-1v-1z"/><path pid="2" d="M14.5 17.008h-12V9.207l8 4.98 8-4.98v.8h2V6.985c0-.71-.379-1.37-.992-1.73L10.5 0 1.492 5.254A2.009 2.009 0 00.5 6.984v10.024c0 1.101.898 2 2 2h12v-2zm-4-14.692l7.89 4.602-7.89 4.91-7.89-4.91 7.89-4.602z"/></g>'
  }
})
